export enum EventPriceTypesEnum {
	Standard = 'f5056b5f-ff83-493f-adc7-58a576878605',
	Group = '80912167-2fd7-459b-94df-cf4585e7abde',
	Unlisted = 'cf4585e7-2fd7-459b-94df-bde80912167a',
}
